// Детект запуска мини-аппа в DEBUG-режиме: бот-команда `/debug` открывает
// мини-апп с payload-маркером (см. бэкенд secret_commands MAX). При этом App
// рендерит DebugPage вместо обычного приложения — чтобы снять диагностику
// MAX-авторизации прямо на устройстве заказчика.
//
// ВАЖНО: детект НЕ полагается на разбор MAX-payload/моста — иначе мы бы не
// сняли диагностику ровно того механизма, который сломан. Смотрим сырой
// launch-URL (снимок window.__LAUNCH_DEBUG сделан инлайном в самом верху
// <head>, ещё ДО того как мост подчистит hash), плюс — как запасной канал —
// уже разобранный start_param.
import { readShareLaunchParam } from "./shareDeepLink";
/**
 * Маркер debug-запуска. Отдельный распознаваемый токен (не голое «debug»),
 * чтобы не ловить случайные вхождения в обычных URL. Совпадает с payload
 * кнопки в MAX-боте (`OpenAppButton(payload="vzdebug")`).
 */
export const DEBUG_LAUNCH_PAYLOAD = "vzdebug";
function launchHaystack() {
    if (typeof window === "undefined")
        return "";
    const snap = window.__LAUNCH_DEBUG;
    const search = snap?.search ?? window.location.search;
    const hash = snap?.hash ?? window.location.hash;
    return `${search}\n${hash}`;
}
/**
 * Запущены ли мы в debug-режиме. Считается один раз на загрузке модуля:
 *  1) маркер присутствует в сыром launch-URL (буквы не url-кодируются, поэтому
 *     токен виден и внутри обёрнутой/закодированной подписанной строки);
 *  2) запасной канал — разобранный start_param равен маркеру.
 */
export const INITIAL_IS_DEBUG_LAUNCH = (() => {
    if (typeof window === "undefined")
        return false;
    if (launchHaystack().toLowerCase().includes(DEBUG_LAUNCH_PAYLOAD))
        return true;
    try {
        return readShareLaunchParam() === DEBUG_LAUNCH_PAYLOAD;
    }
    catch {
        return false;
    }
})();
